import type { CounterpartyMapWithLinks } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { BANK_COUNTERPARTIES_KEY } from 'hooks/keys';
import { useUser } from '../useUser';

export function useCounterparties(crbId?: string, enabled = true) {
  const { userBankId } = useUser();
  const banksApi = new BanksApi();

  const { data, isLoading: isLoadingCounterparties } = useQuery<CounterpartyMapWithLinks>({
    enabled: !!userBankId && enabled,
    queryKey: [BANK_COUNTERPARTIES_KEY, userBankId, crbId],
    queryFn: async () => {
      return await banksApi.getBankCounterparties(userBankId, crbId);
    },
    meta: {
      snackbarErrorMessage:
        'There was an issue loading counterparties. Please try again, or contact support if the problem persists.'
    }
  });

  return { counterpartyMap: data, isLoadingCounterparties };
}
